<template>
  <transition name="modal">
    <div class="modal-mask" >
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <button class="btn btn-light modal-default-button" @click="$emit('close')">
              X
            </button>
            <span class="filter-title">{{ $filters.capitalize(fg.label) }}</span> 
          </div>

          <div class="modal-body">
             <ul class="filter-options row">
                <li v-for="t in buckets" :key="t.key" class="col-sm-4">
                  <span v-if="isSelected(t.key)" class="term-selected text-small">
                    <svg class="svg-icon">
                      <use xlink:href="#i-checkmark"></use>
                    </svg>
                  </span>
                  <a type="button" href="" class="term-label filter-term" @click.prevent="toggleFilterAction(fg.field, t.key)">
                    {{ $filters.capitalize(t.key) }}</a>
                  <span class="term-count">({{ t.doc_count }})</span>
                </li>
                <li class="term-label col-sm-12 space-top-1" v-if="fg.more > 0">
                  <a href="" type="button" @click.prevent="getMore">More...</a>
                </li>
              </ul>
            <div class="loading" v-if="loading">Loading...</div>
          </div>

          <div class="modal-footer">
                {{ selected.length }} selected
                <button class="btn btn-light modal-default-button" @click="$emit('close')">
                Done
              </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
  import { ref, onMounted, getCurrentInstance, computed, reactive, toRaw } from 'vue'
  import { useFacets } from '../composables/useFacets';
  const instance = getCurrentInstance()
  const $eventBus = instance.appContext.config.globalProperties.$eventBus

  const props = defineProps({
    fg: Object
  })

  const {
    toggleFilterAction,
    facetQueryAction
  } = useFacets()

  const emit = defineEmits(['close'])

  const loading = ref(true)

  // need to force updates here for some reason. todo: troubleshoot async prop updates?
  const buckets = ref(toRaw(props.fg.buckets));
  const selected = ref(toRaw(props.fg.selected));
  $eventBus.on('update-facets', (updated) => {
    // console.log('updated', updated)
    buckets.value = updated[props.fg.field].buckets
    selected.value = updated[props.fg.field].selected
  })

  // onMounted(() => {
  //   getMore()
  // })

  const isSelected = (term) => {
    return selected.value.indexOf(term) > -1;
  }

  const getMore = async () => {
    if (props.fg.more > 0) {
      loading.value = false
      const len = props.fg.buckets.length + props.fg.more
      const queryStr = window.location.search.replace(/size=\d\d/, 'size=0')
      await facetQueryAction(props.fg.field, queryStr, len)
      loading.value = false
    }
  }
</script>